import { toaster } from '@/components/ui/toast'
import { userId } from '@state/auth'
import { useMutation, useQuery } from '@tanstack/solid-query'
import { queryClient } from 'src/App'
import { deleteGoReadPost, getGoReadPosts } from './api'

export function useGoRead() {
	const postsQuery = useQuery(() => ({
		queryKey: ['go-read-posts', userId()],
		queryFn: getGoReadPosts,
		enabled: !!userId(),
	}))

	const deleteMutation = useMutation(() => ({
		mutationFn: deleteGoReadPost,
		onSuccess: () => {
			toaster.create({
				title: 'Post deleted',
				type: 'success',
			})
			queryClient.invalidateQueries({ queryKey: ['go-read-posts', userId()] })
		},
		onError: (error: Error) => {
			toaster.create({
				title: 'Error deleting post',
				description: error.message,
				type: 'error',
			})
		},
	}))

	return {
		postsQuery,
		posts: () => postsQuery.data ?? [],
		deletePost: (id: string) => deleteMutation.mutateAsync(id),
		isDeleting: deleteMutation.isPending,
	}
}
